import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReportEntitySchema } from '../models/report-builder-schema.model';
import { ReportResult, ReportSpec } from '../models/report-builder-spec.model';

/**
 * Client for the report-builder backend module. Every route is a POST with a JSON body, matching
 * `WarehouseReportingService`'s convention - an empty body is valid on `schema/`, `run/` always
 * needs at least `entity`.
 */
@Injectable({
  providedIn: 'root'
})
export class ReportBuilderService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getSchema(): Observable<ReportEntitySchema[]> {
    return this.post('schema', {});
  }

  run(spec: ReportSpec): Observable<ReportResult> {
    return this.post('run', spec);
  }

  private post(action: string, body: any): Observable<any> {
    return this.httpClient.post(this._endpoint + 'report-builder/' + action + '/',
      JSON.stringify(body ? body : {}),
      { headers: { 'Content-Type': 'application/json' } });
  }
}
